export const iconFontAwesomeUsersPeopleUserGear = (
	<i className="fa-solid fa-user-gear"></i>
);
